export default {"src":"/_next/static/media/star.fad76e99.svg","height":14,"width":15,"blurWidth":0,"blurHeight":0};